<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>
        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <base-input
                col="4"
                type="text"
                :placeholder="$t('finishedOrders.providerName')"
                v-model="filterOptions.providerName"
              />
              <base-input
                col="4"
                type="text"
                :placeholder="$t('finishedOrders.storeName')"
                v-model="filterOptions.storeName"
              />
              <base-input
                col="4"
                type="text"
                :placeholder="$t('finishedOrders.deliveryName')"
                v-model="filterOptions.deliveryName"
              />
              <!-- Start:: Start Date Input -->
              <base-picker-input
                col="3"
                type="date"
                :placeholder="$t('finishedOrders.from')"
                v-model.trim="filterOptions.from_date"
              />
              <!-- End:: Start Date Input -->

              <!-- Start:: End Date Input -->
              <base-picker-input
                col="3"
                type="date"
                :placeholder="$t('finishedOrders.to')"
                v-model.trim="filterOptions.to_date"
              />
              <!-- End:: End Date Input -->
            </div>

            <div class="btns_wrapper">
              <button class="submit_btn" :disabled="isWaitingRequest">
                <i class="fal fa-search"></i>
              </button>
              <button
                class="reset_btn"
                type="button"
                :disabled="isWaitingRequest"
                @click="resetFilter"
              >
                <i class="fal fa-redo"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>
            {{ $t("unfinishedOrders.name") }}
          </h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>

        <div class="title_route_wrapper">
          <base-button
            class="mt-0 pdf_btn"
            styleType="solid_btn"
            :btnText="$t('BUTTONS.downloadPdf')"
            @fireClick="downloadPdfAllData"
          >
            <template v-slot:btn_icon>
              <i class="fal fa-file-pdf"></i>
            </template>
          </base-button>
          <base-button
            class="mt-0 excel_btn"
            styleType="solid_btn"
            :btnText="$t('BUTTONS.downloadExcel')"
            @fireClick="downloadExcelAllData"
            :disabled="excelDownloadBtnIsLoading"
          >
            <template v-slot:btn_icon>
              <i class="fal fa-file-excel"></i>
            </template>
          </base-button>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <template v-slot:[`item.serial_number`]="{ index }">
          {{
            (paginations.current_page - 1) * paginations.items_per_page +
            index +
            1
          }}
        </template>
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>

        <!-- End:: No Data State -->
        <!-- 
        <template v-slot:[`item.id`]="{ item, index }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.id">
              {{ $t("TABLES.noData") }}
            </h6>
            <p v-else>
              {{
                (paginations.current_page - 1) * paginations.items_per_page +
                index +
                1
              }}
            </p>
          </div>
        </template> -->
        <!-- <template v-slot:[`item`]="{ item }">
          <router-link outer-link :to="`/orders/${item.id}`">
            {{ item.total_subscription }}
          </router-link>
        </template> -->

        <!-- Start:: Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ $t("BUTTONS.show") }}</span>
              </template>
              <button class="btn_show" @click="showItem(item)">
                <i class="fal fa-eye"></i>
              </button>
            </a-tooltip>
          </div>
        </template>
        <!-- End:: Actions -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->

      <!-- ==== Start:: Overall_statistics Addresses ==== -->
      <div class="table_content mt-5">
        <v-simple-table class="stat-table">
          <template v-slot:default>
            <thead class="all-stat">
              <tr>
                <th class="text-center" style="color: white !important">
                  {{ $t("finishedOrders.total_provider_profit") }}
                </th>
                <th class="text-center" style="color: white !important">
                  {{ $t("finishedOrders.total_delivery_profit") }}
                </th>
                <th class="text-center" style="color: white !important">
                  {{ $t("finishedOrders.total_tax") }}
                </th>
                <th class="text-center" style="color: white !important">
                  {{ $t("finishedOrders.total_management_profit") }}
                </th>
                <th class="text-center" style="color: white !important">
                  {{ $t("finishedOrders.total_finished_orders") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center">
                <td>{{ totals.total_provider_profit }}</td>
                <td>{{ totals.total_delivery_profit }}</td>
                <td>{{ totals.total_tax }}</td>
                <td>{{ totals.total_management_profit }}</td>
                <td>{{ totals.total_finished_orders }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <!-- ==== End:: Overall_statistics Addresses ==== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->

    <!-- Start:: Generate PDF Template Content -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :filename="$t('PLACEHOLDERS.report_data')"
      :pdf-quality="2"
      pdf-format="a4"
      :manual-pagination="false"
      :paginate-elements-by-height="1400"
      pdf-content-width="100%"
      @hasGenerated="$message.success($t('MESSAGES.generatedSuccessfully'))"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="pdf_file_content">
          <h3 class="file_title">
            {{ $t("PLACEHOLDERS.report_data") }}
          </h3>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th v-for="header in tableHeaders" :key="header.value">
                    <span>{{ header.text }}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in tableRows" :key="row.id">
                  <td>
                    {{
                      (paginations.current_page - 1) *
                        paginations.items_per_page +
                      index +
                      1
                    }}
                  </td>
                  <td>{{ row.id }}</td>
                  <td>{{ row.date }}</td>
                  <td>{{ row.user.name }}</td>
                  <td>{{ row.provider.name }}</td>
                  <td>{{ row.driver?.name }}</td>
                  <td>{{ row.summary.provider_profit }}</td>
                  <td>{{ row.summary.driver_profit }}</td>
                  <td>{{ row.summary.tax_amount }}</td>
                  <td>{{ row.summary.total }}</td>
                  <td>{{ row.summary.total }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <!-- ==== Start:: Overall_statistics Addresses ==== -->
          <div class="table_content mt-5">
            <v-simple-table class="stat-table">
              <template v-slot:default>
                <thead class="all-stat">
                  <tr>
                    <th class="text-center" style="color: white !important">
                      {{ $t("finishedOrders.total_provider_profit") }}
                    </th>
                    <th class="text-center" style="color: white !important">
                      {{ $t("finishedOrders.total_delivery_profit") }}
                    </th>
                    <th class="text-center" style="color: white !important">
                      {{ $t("finishedOrders.total_tax") }}
                    </th>
                    <th class="text-center" style="color: white !important">
                      {{ $t("finishedOrders.total_management_profit") }}
                    </th>
                    <th class="text-center" style="color: white !important">
                      {{ $t("finishedOrders.total_finished_orders") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="text-center">
                    <td>{{ totals.total_provider_profit }}</td>
                    <td>{{ totals.total_delivery_profit }}</td>
                    <td>{{ totals.total_tax }}</td>
                    <td>{{ totals.total_management_profit }}</td>
                    <td>{{ totals.total_finished_orders }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <!-- ==== End:: Overall_statistics Addresses ==== -->
        </div>
      </section>
    </vue-html2pdf>
    <!-- End:: Generate PDF Template Content -->
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import { mapGetters } from "vuex";
import * as XLSX from "xlsx";

export default {
  name: "AllFinancialUnFinishedOrders",

  components: {
    VueHtml2pdf,
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  data() {
    return {
      loading: false,
      isWaitingRequest: false,
      excelDownloadBtnIsLoading: false,
      total: [],
      filterFormIsActive: false,
      filterOptions: {
        providerName: null,
        storeName: null,
        deliveryName: null,
        from_date: null,
        to_date: null,
      },
      tableHeaders: [
        {
          text: this.$t("TABLES.Clients.serialNumber"),
          value: "serial_number",
          align: "center",
          width: "80",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.orderNum"),
          value: "id",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("finishedOrders.orderDate"),
          value: "date",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("finishedOrders.clientName"),
          value: "user.name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("finishedOrders.providerName"),
          value: "provider.name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("finishedOrders.deliveryName"),
          value: "driver.name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("finishedOrders.provider_profit"),
          value: "summary.provider_profit",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("finishedOrders.delivery_profit"),
          value: "summary.driver_profit",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("finishedOrders.tax"),
          value: "summary.tax_amount",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("finishedOrders.management_profit"),
          value: "summary.admin_total_profit",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("finishedOrders.total_order"),
          value: "summary.total",
          align: "center",
          sortable: false,
        },
      ],
      tableRows: [],
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 6,
      },
      totals: {
        total_provider_profit: null,
        total_delivery_profit: null,
        total_tax: null,
        total_management_profit: null,
        total_finished_orders: null,
      },
      // translatedData: [],
    };
  },

  methods: {
    async submitFilterForm() {
      this.setTableRows();
    },
    async resetFilter() {
      this.filterOptions.providerName = null;
      this.filterOptions.storeName = null;
      this.filterOptions.deliveryName = null;
      this.filterOptions.from_date = null;
      this.filterOptions.to_date = null;
      this.setTableRows();
    },
    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "reports",
          params: {
            page: this.paginations.current_page,
            provider_name: this.filterOptions.providerName,
            provider_name: this.filterOptions.storeName,
            driver_name: this.filterOptions.deliveryName,
            "data[from]": this.filterOptions.from_date,
            "data[to]": this.filterOptions.to_date,
          },
        });
        this.loading = false;
        this.tableRows = res.data.data.items.data;
        console.log("unfinished", res);

        this.totals.total_provider_profit =
          res.data.data.totals.provider_profits;
        this.totals.total_delivery_profit = res.data.data.totals.driver_profits;
        this.totals.total_tax = res.data.data.totals.total_tax;
        this.totals.total_management_profit = res.data.data.totals.admin_profit;
        this.totals.total_finished_orders =
          res.data.data.totals.num_of_complete_orders;

        this.paginations.items_per_page = res.data.data.items.meta.per_page;
        this.paginations.last_page = res.data.data.items.meta.last_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    async downloadExcelAllData() {
      try {
        const response = await this.$axios.get(
          `https://backend.modoapp.net/dashboard-api/v1/reports`,
          {
            params: { format: "excel" },
            responseType: "blob",
          }
        );

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;

        // اسم الملف: ممكن استخدام أي جزء من item لتخصيص الاسم
        link.setAttribute(
          "download",
          `${this.$t("PLACEHOLDERS.report_data")}.xlsx`
        );

        // تنفيذ التحميل
        document.body.appendChild(link);
        link.click();

        // تنظيف
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("خطأ أثناء تحميل الملف:", error);
        this.$message.error("حدث خطأ أثناء تحميل ملف الـ Excel.");
      }
    },
    async downloadPdfAllData() {
      try {
        const response = await this.$axios.get(
          `https://backend.modoapp.net/dashboard-api/v1/reports`,
          {
            params: { format: "pdf" },
            responseType: "blob",
          }
        );

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;

        // اسم الملف: ممكن استخدام أي جزء من item لتخصيص الاسم
        link.setAttribute(
          "download",
          `${this.$t("finishedOrders.financial_reports")}.pdf`
        );

        // تنفيذ التحميل
        document.body.appendChild(link);
        link.click();

        // تنظيف
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("خطأ أثناء تحميل الملف:", error);
        this.$message.error("حدث خطأ أثناء تحميل ملف الـ Excel.");
      }
    },
  },

  created() {
    this.setTableRows();
  },
};
</script>

<style scoped>
.ex-btn-s {
  color: black !important;
  font-size: 20px;
  font-weight: bold;
  text-decoration: underline !important;
}

.all-stat {
  background: var(--main_theme_clr);
}

.all-stat th {
  color: white !important;
  font-size: 16px !important;
  font-weight: 800;
}

.excel {
  background: darkgreen;
  padding: 7px 10px;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
}
</style>
